import { WEB_API_ROUTES } from 'api/api-routes';
import api from 'api';
import { createThunk } from '../../utils/storeUtils';

export const thunks = {
  getConnectedAccounts: createThunk('profile/getConnectedAccounts', () =>
    api.get(WEB_API_ROUTES.profile.connections)
  ),

  getUserInfo: createThunk('profile/getUserInfo', () =>
    api.get(WEB_API_ROUTES.profile.info)
  ),

  updateUserInfo: createThunk('profile/updateUserInfo', (data) =>
    api.post(WEB_API_ROUTES.profile.info, data)
  ),
};
